



































































import { Vue, Component, Lifecycle, Prop, p } from "av-ts";
import { IUser, IRecommendation, IRecommendedRole } from "../../interfaces/models";
import UserService from "../../services/UserService";
import Fetcher from "../../services/Fetcher";
import RoleChip from "./RoleChip.vue";
import { serverToLocalFullAMPMTime } from "../../util";

interface IMeetingHistory {
    name: string,
    id: number
};

@Component({
    components: {
        RoleChip
    }
})
export default class RecommendationReviewCard extends Vue {
    @Prop recommendation = p<IRecommendation>({
        required: true
    });

    pMeetingHistory: IMeetingHistory[] = [];
    updateMeetingHistory(newHistory: IMeetingHistory[]) {
        this.pMeetingHistory = newHistory;
    }

    meetingLocation = "";

    @Lifecycle
    created() {
        Fetcher.get(UserService.getMeetingHistory)
            .on(this.updateMeetingHistory);
    }

    findItem(toSearch: IMeetingHistory[], query: string) {
        return toSearch.filter(x => x.name.toLowerCase().indexOf(query.toLowerCase()) >= 0);
    }

    ignoreRecommendation() {
        this.$emit("change", this.recommendation.id, "rejected");
    }

    acceptRecommendation() {
        this.$emit("change", this.recommendation.id, "accepted");
    }

    get meetingTime() {
        return serverToLocalFullAMPMTime(this.recommendation.eventTime);
    }

    get meetingHistory() {
        return (a: { q: string }) => Promise.resolve(this.findItem(this.pMeetingHistory, a.q));
    }

    get user(): IUser {
        return this.recommendation.recommendedOfferingUser.user;
    }

    get userRoles(): IRecommendedRole[] {
        if (this.recommendation) {
            return this.recommendation.recommendedRole;
        } else {
            return [];
        }
    }

    get location(): string {
        return this.recommendation.location;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/peers/RecommendationReviewCard.vue